/** Phân quyền — nhà cung cấp */
export const NHA_CUNG_CAP_PERMISSION_CODES = {
  WEB_BH_NHA_CUNG_CAP_LIST: 'WEB_BH_NHA_CUNG_CAP_LIST',
  WEB_BH_NHA_CUNG_CAP_ADD: 'WEB_BH_NHA_CUNG_CAP_ADD',
  WEB_BH_NHA_CUNG_CAP_EDIT: 'WEB_BH_NHA_CUNG_CAP_EDIT',
  WEB_BH_NHA_CUNG_CAP_DELETE: 'WEB_BH_NHA_CUNG_CAP_DELETE',
  WEB_BH_NHA_CUNG_CAP_TOGGLE_STATUS: 'WEB_BH_NHA_CUNG_CAP_TOGGLE_STATUS',
  WEB_BH_NHA_CUNG_CAP_IMPORT: 'WEB_BH_NHA_CUNG_CAP_IMPORT',
  WEB_BH_NHA_CUNG_CAP_EXPORT: 'WEB_BH_NHA_CUNG_CAP_EXPORT',
} as const

export type NhaCungCapPermissionCode =
  (typeof NHA_CUNG_CAP_PERMISSION_CODES)[keyof typeof NHA_CUNG_CAP_PERMISSION_CODES]

export const NHA_CUNG_CAP_MUTATE_PERMISSIONS = [
  NHA_CUNG_CAP_PERMISSION_CODES.WEB_BH_NHA_CUNG_CAP_ADD,
  NHA_CUNG_CAP_PERMISSION_CODES.WEB_BH_NHA_CUNG_CAP_EDIT,
  NHA_CUNG_CAP_PERMISSION_CODES.WEB_BH_NHA_CUNG_CAP_DELETE,
  NHA_CUNG_CAP_PERMISSION_CODES.WEB_BH_NHA_CUNG_CAP_TOGGLE_STATUS,
  NHA_CUNG_CAP_PERMISSION_CODES.WEB_BH_NHA_CUNG_CAP_IMPORT,
] as const
